const dayjs = require('dayjs')
const timezone = require('dayjs/plugin/timezone')
const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
dayjs.extend(timezone)

const dateFilterLong = function(dte, tz) {
  // If timezone is not set, guess!
  if (tz === undefined || !tz) {
    tz = dayjs.tz.guess()
  }

  return dayjs(dte, 'YYYY-MM-DD hh:mm:ss Z').tz(tz).format('ddd, Do MMMM Y')
}

export default dateFilterLong
